import { FormattedMessage } from '@alltrails/shared/react-intl';
import * as styles from './MiniFooter.module.scss';
import Link from '@alltrails/shared/denali/components/Link';

function MiniFooter() {
  return (
    <div className={styles.container}>
      <div className={styles.text}>
        <div className={styles.rightsReserved}>
          <FormattedMessage
            defaultMessage="{year} AllTrails, LLC All Rights Reserved"
            values={{
              year: new Date().getFullYear()
            }}
          />
        </div>
        <div className={styles.links}>
          <Link className={styles.link} href="/privacy" noUnderline>
            <FormattedMessage defaultMessage="Privacy Policy" />
          </Link>
          |
          <Link className={styles.link} href="/terms" noUnderline>
            <FormattedMessage defaultMessage="Terms of Service" />
          </Link>
        </div>
      </div>
    </div>
  );
}

export default MiniFooter;
